import React from 'react'

/** Compact segmented control for tabs and table toolbars (content-width options, active one filled). */
const SegmentedSwitch = ({ options, value, onChange }) => (
    <div className="segmentedSwitch" role="tablist">
        {
            options.map(o => {
                const active = value === o.key
                return (
                    <div
                        key={o.key}
                        className={`segmentedSwitchOption${active ? ' segmentedSwitchOption--active' : ''}`}
                        role="tab"
                        tabIndex={0}
                        aria-selected={active}
                        onClick={() => onChange(o.key)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') onChange(o.key)
                        }}
                    >
                        {o.label}
                    </div>
                )
            })
        }
    </div>
)

export default SegmentedSwitch
